import * as _ from 'underscore';

import { IDatabase } from '../ServerApi/types/IDatabase';
import { IDatabaseInfo } from '../models/IDatabaseInfo';
import { MapperHelper } from './MapperHelper';
import { IDownstreamWorkbooksConnectionInfo, IDownstreamDatasourcesConnectionInfo, IDataQualityWarningInfo, IDataQualityWarningAuthorInfo, ICatalogContactInfo } from '../models/resourceInfoParts';
import { IUserInfo } from '../models/IUserInfo';


export module DatabaseWithCrassMapper {

    const M = MapperHelper;

    export function map(
        serverApiDatabases: IDatabase[],
      ): IDatabaseInfo[] {
          return _.map(serverApiDatabases, (db: IDatabase) => {
            const dbInfo: IDatabaseInfo = {
                __typename:                         db.dbType,
                connectionType:                     db.connectionType,
                contact:                            db.contact ? mapContact(db) : null,
                createdAt:                          M.toDate(db.createdAt),
                dataQualityWarning:                 mapDataQualityWarning(db),
                downstreamWorkbooksConnection:      mapDownstreamWorkbooks(db),
                downstreamDatasourcesConnection:    mapDownstreamDatasources(db),
                filePath:                           db.filePath,
                hostName:                           db.hostName,
                id:                                 db.id,
                isCertified:                        db.isCertified,
                isEmbedded:                         db.isEmbedded,
                isGroupedParent:                    db.isGroupedParent,
                luid:                               db.luid,
                name:                               db.name,
                site:                               {id: db.siteId, luid: db.siteLuid, urlName: ''},
                tags:                               db.tags,
                updatedAt:                          M.toDate(db.updatedAt)
            };
            return dbInfo;
          });
        }

    export function mapDownstreamWorkbooks(db: IDatabase): IDownstreamWorkbooksConnectionInfo {
        const dsWorkbookConnection: IDownstreamWorkbooksConnectionInfo = {
            totalCount: db.downstreamWorkbookCount
        };
        return dsWorkbookConnection;
    }

    export function mapDownstreamDatasources(db: IDatabase): IDownstreamDatasourcesConnectionInfo {
        const dsDatasourcesConnection: IDownstreamDatasourcesConnectionInfo = {
            totalCount: db.downstreamDataSourceCount
        };
        return dsDatasourcesConnection;
    }


    export function mapDataQualityWarning(db: IDatabase): IDataQualityWarningInfo {
        const dataQualityAuthor: IDataQualityWarningAuthorInfo = {
            username: '',
            name:     '',
            domain:   ''
        };
        const dataQualityWarning: IDataQualityWarningInfo = {
            isActive:          !!db.hasActiveDataQualityWarning,
            isSevere:          !!db.hasSevereDataQualityWarning,
            author:            dataQualityAuthor,
        };
        return dataQualityWarning;
    }

    export function mapContact(db: IDatabase): ICatalogContactInfo {
        const userInfo: ICatalogContactInfo = {
            id:                 db.contact.id,
            readOnly:           db.contact.readOnly,
            username:           db.contact.username,
            name:               db.contact.displayName,
            domain:             db.contact.domainName,
            hasServerDisplay:   db.contact.hasServerDisplay
        };
        return userInfo;
    }
}